import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { AdDesktopAddressHP } from '../advertising/InlineDesktopAdBanner'
import { AdMobileBannerAddress } from '../advertising/InlineMobileAdBanner'
import Footer from '../footer/Footer'
import { useScrollContext } from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import { withEverySelectorTruthy } from '../utils/react-redux'
import AddressContent from './AddressContent'
import s from './AddressMainContent.less'
import { AddressVdeBanner } from './AddressVdeBanner'
import EtaAndItineraryButton from './EtaAndItineraryButton'
import FakeHotelCalendar from './FakeHotelCalendar'
import GeoentitiesAtAddress from './GeoentitiesAtAddress'
import GeoentitiesAtAddressPicker from './GeoentitiesAtAddressPicker'

const AddressMainContent = () => {
  const address = useSelector(selectFirstAddress)
  const { label } = address
  const { scrollTop } = useScrollContext()

  useEffect(() => {
    if (label) scrollTop()
  }, [label])

  return (
    <>
      <div className={s.addressMainContent}>
        <EtaAndItineraryButton location={address} />
        <AddressContent address={address} />
        <AdDesktopAddressHP />
        <AddressVdeBanner />
        <GeoentitiesAtAddress />
        <GeoentitiesAtAddressPicker />
        <AdMobileBannerAddress />
        <FakeHotelCalendar />
      </div>
      <Footer />
    </>
  )
}

export default withEverySelectorTruthy(selectFirstAddress)(AddressMainContent)
